(() => {
  function init(root = document) {
    const variant = root.querySelector('#VariantSelect');
    if (variant && !variant.dataset.bound) {
      variant.dataset.bound = 'true';
      variant.addEventListener('change', () => {
        const option = variant.selectedOptions[0];
        root.querySelector('#ProductPrice').textContent = option.dataset.price;
        const button = root.querySelector('.add-to-bag');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Sold out' : 'Add to cart';
        const url = new URL(location.href); url.searchParams.set('variant', variant.value);
        history.replaceState({}, '', url);
      });
    }
    root.querySelectorAll('[data-gallery-src]').forEach(button => {
      if (button.dataset.bound) return; button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const img = root.querySelector('#ProductImage');
        img.src = button.dataset.gallerySrc; img.alt = button.dataset.galleryAlt;
        root.querySelectorAll('[data-gallery-src]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      });
    });
    root.querySelectorAll('[data-zoom], [data-open-image]').forEach(button => {
      if (button.dataset.bound) return; button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        const dialog = document.getElementById('ImageZoom');
        const source = button.querySelector('img');
        const img = dialog.querySelector('img');
        img.src = button.dataset.openImage || source.src;
        img.alt = button.dataset.imageAlt || source.alt;
        dialog.showModal();
      });
    });
    const filters = [...root.querySelectorAll('[data-filter]')];
    const applyFilter = goal => {
      filters.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === goal)));
      root.querySelectorAll('[data-filter-grid] [data-product-goal]').forEach(card => { card.hidden = goal !== 'all' && !(' ' + (card.dataset.productGoal || '') + ' ').includes(' ' + goal + ' '); });
    };
    filters.forEach(button => {
      if (button.dataset.bound) return; button.dataset.bound = 'true';
      button.addEventListener('click', () => {
        applyFilter(button.dataset.filter);
        const url = new URL(location.href);
        if (button.dataset.filter === 'all') url.searchParams.delete('goal'); else url.searchParams.set('goal', button.dataset.filter);
        history.replaceState({}, '', url);
      });
    });
    const goal = new URL(location.href).searchParams.get('goal');
    if (goal && filters.some(b => b.dataset.filter === goal)) applyFilter(goal);
    const form = root.querySelector('#ProductForm');
    if (form && !form.dataset.bound) {
      form.dataset.bound = 'true';
      form.addEventListener('submit', async event => {
        if (!window.fetch) return;
        event.preventDefault();
        if (form.dataset.submitting === 'true') return;
        if (window.PotencyPopups?.offerSubscription(form)) return;
        form.dataset.submitting = 'true';
        const button = form.querySelector('.add-to-bag');
        const status = form.querySelector('.form-feedback');
        button.disabled = true; button.textContent = 'Adding…'; status.textContent = '';
        try {
          const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
          if (window.PotencyCart) {
            form.dataset.submitting = 'false';
            button.disabled = false; button.textContent = 'Add to cart';
            status.textContent = 'Added to your bag.';
            setTimeout(() => { if (status.textContent === 'Added to your bag.') status.textContent = ''; }, 4000);
            window.PotencyCart.open();
          } else {
            status.textContent = 'Added to your bag. Opening your bag…';
            location.href = (window.Shopify?.routes?.root || '/') + 'cart';
          }
        } catch (error) {
          form.dataset.submitting = 'false';
          status.textContent = error.message || 'Unable to add this item. Please try again.';
          button.disabled = false; button.textContent = 'Add to cart';
        }
      });
    }
  }
  document.querySelectorAll('[data-close-dialog]').forEach(b => b.addEventListener('click', () => b.closest('dialog').close()));
  document.querySelectorAll('dialog').forEach(d => d.addEventListener('click', e => { if (e.target === d) d.close(); }));
  document.addEventListener('shopify:section:load', e => init(e.target));
  init();
})();
